<template>
  <main role="main" class="col content-spacing">
    <loading-list v-if="viewData.loading"></loading-list>
    <b-container v-else>
      <b-row>
        <b-col>
          <div
            class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
          >
            <h1 class="h2">
              {{ viewData.id ? `Editar ${state.name}` : 'Novo Convênio' }}
            </h1>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-breadcrumb
            :items="[
              {
                text: 'Lista de Convênios',
                href: '#/covenant',
              },
              {
                text: 'Cadastro de Convênios',
                href: '#',
                active: true,
              },
            ]"
          ></b-breadcrumb>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-form>
              <error-container v-bind:errors="viewData.errors || []" />

              <b-form-group label="Nome (Sigla)">
                <b-form-input
                  v-model="state.name"
                  required
                  placeholder="Informe o nome do convênio"
                  :state="isOk('name')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('name')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Registro">
                <b-form-input
                  v-model="state.register"
                  required
                  placeholder="Informe o registro do convênio"
                  :state="isOk('register')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('register')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Tipo">
                <b-form-input
                  v-model="state.type"
                  required
                  placeholder="Informe o tipo do convênio"
                  :state="isOk('type')"
                ></b-form-input>
                <b-form-invalid-feedback>{{
                  getError('type')
                }}</b-form-invalid-feedback>
              </b-form-group>

              <submit-button
                v-bind:action="() => save()"
                v-bind:label="'Salvar'"
              ></submit-button>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';

const API = new Api();

export default {
  name: 'distributor-edit',
  data: function() {
    return {
      state: {
      },
      viewData: {
        id: 0,
        loading: false,
        errors: [],
      },
    };
  },
  computed: {},
  beforeMount: async function() {
    const _id = this.$route.params ? this.$route.params.id : 0;

    if (_id) {
      this.viewData.id = _id;

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/covenant/' + _id,
          method: 'get',
        });

        this.state = { ...result.model };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    }
  },
  methods: {
    getError(property) {
      return helpers.getError(this.viewData.errors, property);
    },
    isNumber($event) {
      return helpers.isNumber($event);
    },
    isOk(property) {
      let hasError = helpers.hasError(this.viewData.errors, property);
      if (hasError) {
        return false;
      }
    },
    async save() {
      try {
        const result = await API.post('/execute', {
          path: this.viewData.id
            ? `/covenant/${this.viewData.id}`
            : '/covenant/',
          method: this.viewData.id ? 'put' : 'post',
          data: this.state,
        });
        this.$router.push('/covenant');
        this.$toast.success('Convênio incluído com sucesso');
      } catch (ex) {
        this.viewData.errors = helpers.getErrors(ex);
      }
    }
  },
};
</script>
